import { useMutation, useNotify, useRefresh } from "react-admin";
import { StyledButton } from "../../../components/ListShowButton";

interface IPostBatchInvoiceButton {
  rateChartId: number;
  resource: string;
}

const PostBatchInvoiceButton = ({
  rateChartId,
  resource,
}: IPostBatchInvoiceButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [handleChangeStatusStudent, { loading }] = useMutation(
    {
      type: "customCreate",
      resource: `${resource}/${rateChartId}/postInvoices`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully post the invoices.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(`Failed post the invoices, error: ${error.message}`, "warning"),
    }
  );

  return (
    <StyledButton
      onClick={handleChangeStatusStudent}
      variant="outlined"
      style={{ color: "#1976d2", borderColor: "#1976d2" }}
    >
      {loading ? "Please wait..." : "POST"}
    </StyledButton>
  );
};

export default PostBatchInvoiceButton;
